import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contact from '@/components/contact'
import Apply from '@/components/apply'
import Form from '@/components/formPage'
import Activity from '@/components/activityPage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }, {
    path: '/apply',
    name: 'Apply',
    component: Apply
  }, {
    path: '/form',
    name: 'Form',
    component: Form
  }, {
    path: '/activity',
    name: 'Activity',
    component: Activity
  }
]

const router = new VueRouter({
  routes
})

export default router
